import Auth from '../components/UI/Auth/Auth';
import Header from '../components/UI/Header/Header';

const AuthPage = () => {

  return (
    <div>
      <Header />
      <Auth />
    </div>
  )
}

export default AuthPage
